import { render, staticRenderFns } from "./ContentImportMetadata.vue?vue&type=template&id=32425a88&"
import script from "./ContentImportMetadata.vue?vue&type=script&lang=ts&"
export * from "./ContentImportMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports